import IFrame1 from "./iFrame1/IFrame1";
import IFrame2 from "./iFrame2/IFrame2";
import IFrame3 from "./iFrame3/IFrame3";
import IFrame4 from "./iFrame4/IFrame4";
import IFrame5 from "./iFrame5/IFrame5";
import IFrame6 from "./iFrame6/IFrame6";
import IFrame7 from "./iFrame7/IFrame7";
import IFrame8 from "./iFrame8/IFrame8";
import IFrame9 from "./iFrame9/IFrame9";
import IFrame10 from "./iFrame10/IFrame10";
import IFrame11 from "./iFrame11/IFrame11";
import IFrame12 from "./iFrame12/IFrame12";

export const getIFrameById = (id, iFrameData, fileData) => {
    const iFrameList = {
        1: <IFrame1 iFrameData={iFrameData} fileData={fileData} />,
        2: <IFrame2 iFrameData={iFrameData} fileData={fileData} />,
        3: <IFrame3 iFrameData={iFrameData} fileData={fileData} />,
        4: <IFrame4 iFrameData={iFrameData} fileData={fileData} />,
        5: <IFrame5 iFrameData={iFrameData} fileData={fileData} />,
        6: <IFrame6 iFrameData={iFrameData} fileData={fileData} />,
        7: <IFrame7 iFrameData={iFrameData} fileData={fileData} />,
        8: <IFrame8 iFrameData={iFrameData} fileData={fileData} />,
        9: <IFrame9 iFrameData={iFrameData} fileData={fileData} />,
        10: <IFrame10 iFrameData={iFrameData} fileData={fileData} />,
        11: <IFrame11 iFrameData={iFrameData} fileData={fileData} />,
        12: <IFrame12 iFrameData={iFrameData} fileData={fileData} />,
    };
    return iFrameList[id];
};
